<template>
<v-layout align-space-between justify-space-between column fill-height>
    <v-flex
        xs12
        id="teneo-chat-scroll"
        :class="{'dark-scroll': dark, 'light-scroll': !dark, 'chat-responses-float': float, 'chat-responses': !float}"
        ref="chatContainer"
      >
        <ChatLoading v-if="showChatLoading"></ChatLoading>
        <!-- <v-expansion-panel
          :value="getCurrentItem"
          class="chat-container-inner"
        >
          <transition-group
            name="chat-line-transition"
            enter-active-class="animated fadeIn"
          >
            <v-expansion-panel-content
              class="teneo-dialog"
              v-for="(item,i) in dialog"
              :key="i + 'itemsIter' + uuid"
              :hide-actions="true"
              :class="{'pb-2': (i === dialog.length - 1), 'pt-2': (i === 0)}"
            >

              <div slot="header">
                <v-container
                  grid-list-xs
                  fluid
                >
                  <ChatBroadcastMessage :item="item"></ChatBroadcastMessage>

                  <LiveChatResponse :item="item"></LiveChatResponse>

                  <ChatTeneoResponse
                    :item="item"
                    :itemIndexInDialog="i"
                    @swapInputButton="swapInputButton"
                    @handleFocus="handleFocus"
                    @toggleDate="showDate = !showDate"
                    @toggleTime="showTime = !showTime"
                  ></ChatTeneoResponse>

                  <ChatUserQuestion
                    :item="item"
                    @clicked="updateInputBox"
                    @swapInputButton="swapInputButton"
                  ></ChatUserQuestion>

                </v-container>
              </div>
            </v-expansion-panel-content>
          </transition-group>

          <div
            class="text-xs-center my-3"
            v-if="showLiveChatProcessing"
          >
            <ball-pulse-sync-loader
              color="#C2C2C2"
              size="10px"
            ></ball-pulse-sync-loader>
          </div>

          <span
            id="scroll-end"
            ref="pageBottom"
          ></span>
        </v-expansion-panel> -->

    </v-flex>
    <!-- <v-flex
        xs12
        class="teneo-footer transparent"
      >
        <v-progress-linear
          :indeterminate="true"
          :active="progressBar"
          class="teneo-input-loading"
          height="3"
        ></v-progress-linear>
         <v-container fluid grid-list-sm>
              <v-form
                  v-model="valid"
                  v-on:submit.prevent
                  ref="userInputForm"
                  style="height: 30px;"
                >
                     <v-layout row>
                          <v-flex xs12 pl-3>
                                 <v-text-field
                                  id="teneo-input-field"
                                  v-show="!showUploadButton && !showUploadProgress"
                                  :disabled="progressBar"
                                  :append-icon="showAudioInput ? 'fa-angle-double-right' : ''"
                                  @click:append="sendUserInput"
                                  v-shortkey="{toggle1: ['ctrl', 'alt', '/'], toggle2: ['ctrl', 'alt', 'arrowdown']}"
                                  @shortkey.native="swapInputButton"
                                  :prepend-inner-icon="askingForPassword ? showPassword ? 'visibility' : 'visibility_off' : ''"
                                  :type="askingForPassword ? showPassword ? 'text' : 'password' : 'text'"
                                  @click:prepend-inner="showPassword = !showPassword"
                                  :rules="askingForEmail ? [rules.email(userInput)] : []"
                                  clearable
                                  auto-grow
                                  required
                                  return-masked-value
                                  :mask="itemInputMask"
                                  solo
                                  name="userInput"
                                  ref="userInput"
                                  browser-autocomplete="off"
                                  @keyup.enter.native="sendUserInput"
                                  v-model="userInput"
                                  :label="inputHelpText ? inputHelpText : 'Say something...'"
                                  single-line
                                ></v-text-field>
                                <span
                                  v-shortkey="['esc']"
                                  @shortkey="stopAudioCapture"
                                ></span>
                          </v-flex>
                          <v-flex>
                              <upload-btn
                                icon
                                v-if="showUploadButton"
                                :fileChangedCallback="fileChanged"
                                large
                                hover
                                class="mx-0 px-0"
                              >
                                <template slot="icon">
                                  <v-icon dark>mdi-paperclip</v-icon>
                                </template>
                              </upload-btn>
                              <v-progress-circular
                                v-if="showUploadProgress"
                                :rotate="360"
                                :size="40"
                                :width="10"
                                :value="progressValue"
                                color="primary"
                                class="mx-2 mt-1"
                              >
                              </v-progress-circular>
                              <template v-if="!showUploadButton && !showUploadProgress">
                                <v-btn
                                  fab
                                  :disabled="progressBar"
                                  :loading="progressBar"
                                  v-long-press="1000"
                                  @long-press-start="swapInputButton"
                                  v-if="!showAudioInput"
                                  small
                                  color="primary"
                                  class="white--text elevation-2"
                                  @click.native="sendUserInput"
                                >
                                  <v-icon>send</v-icon>
                                </v-btn>

                                <v-btn
                                  fab
                                  :disabled="progressBar"
                                  :loading="progressBar"
                                  v-long-press="1000"
                                  @long-press-start="swapInputButton"
                                  small
                                  v-if="showAudioInput"
                                  v-shortkey="{recordAudioOne: ['ctrl', 'alt', '.'], recordAudioTwo: ['ctrl', 'alt', '`'], recordAudioThree: ['ctrl', 'alt', 'arrowup']}"
                                  @shortkey.native="captureAudio"
                                  :color="audioButtonColor"
                                  :class="audioButtonClasses"
                                  class="elevation-2"
                                  @click.native="captureAudio"
                                >
                                  <v-icon medium>fa-microphone-alt</v-icon>
                                </v-btn>
                              </template>
                            </v-flex>
                     </v-layout>

              </v-form>
         </v-container>

    </v-flex> -->
</v-layout>
</template>
<script>
import ChatLoading from "@/components/chat/ChatLoading";
import LongPress from "vue-directive-long-press";
//import ChatNoHistory from "../components/ChatNoHistory";
export default {
      components: {
        ChatLoading,
      },
       directives: {
        "long-press": LongPress
      },
      data() {
        return {
          userInput: '',
          dark : false,
          float : false,
          showChatLoading: false,
          progressBar: false,
          valid: false,
          showUploadButton: false,
          showUploadProgress: false,
          showAudioInput: false,
          askingForPassword: false,
          showPassword: false,
          askingForEmail: false,
          itemInputMask: '',
          inputHelpText: ''

        }
    },
    methods : {
       captureAudio() {

       },
       sendUserInput(){

       },
       stopAudioCapture(){

       },
       swapInputButton(){

       }
    }
}
</script>
<style scoped>
.loading-ball {
  width: 360px;
}

.container {
  padding: 0 !important;
}

.teneo-input-loading {
  position: relative;
  margin: 0 !important;
  /* bottom: 3px; */
}
</style>
<style>
div#chat-area p {
  margin-bottom: 5px;
}
div.teneo-footer{
  position: fixed;
    bottom: 55px !important;
}
div.teneo-footer .v-input__slot {
  -webkit-box-shadow: unset !important;
  box-shadow: unset !important;
  background: transparent !important;
  padding-left: 5px !important;
}

div.teneo-footer .v-text-field__details {
  position: relative !important;
  bottom: 20px !important;
}

div.chat-container .v-expansion-panel__header {
  padding-left: 8px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
  padding-bottom: 5px !important;
  cursor: unset;
}

.v-toolbar__title:not(:first-child) {
  margin-left: 12px !important;
}

.v-toolbar__title {
  font-size: 17px !important;
  white-space: unset !important;
}

/* .v-toolbar__content,
.v-toolbar__extension {
  padding: 0 12px;
} */

@media screen and (-ms-high-contrast: active),
  screen and (-ms-high-contrast: none) {
  /* IE10+ specific styles go here */
  .chat-card {
    font-size: 16px !important;
    font-weight: 500;
    padding: 5px;
    padding-left: 10px;
    margin-top: 10px;
    width: 260px;
  }
}

.chat-card {
  font-size: 16px !important;
  font-weight: 500;
  padding: 5px;
  padding-left: 10px;
  margin-top: 10px;
}

.chat-card-left {
  border-radius: 3px 13px 13px 13px;
  -moz-border-radius: 3px 13px 13px 13px;
  -webkit-border-radius: 3px 13px 13px 13px;
}

.chat-card-right {
  border-radius: 13px 3px 13px 13px;
  -moz-border-radius: 13px 3px 13px 13px;
  -webkit-border-radius: 13px 3px 13px 13px;
}

div.options-list a.v-list__tile--link {
  cursor: pointer;
  height: inherit !important;
}

.teneo-response-icon {
  margin-left: 0px;
  margin-right: 5px;
}

.teneo-userinput-icon {
  margin-right: 0px;
  margin-left: 5px;
}

.teneo-dialog {
  width: 360px;
  max-width: none;
  border-top: unset !important;
  padding-left: 10px;
  padding-right: 10px;
}

.chat-responses-float {
  min-height: calc(80vh - 130px);
  max-height: calc(80vh - 130px);
  height: calc(80vh - 130px);
  /* height: calc(var(--vh, 1vh) * 80 - 130px); */
  overflow-y: auto;
  overflow-x: hidden;
}

.chat-responses {
  min-height: calc(100vh - 130px);
  /* min-height: calc(var(--vh, 1vh) * 100 - 130px); */
  max-height: calc(100vh - 130px);
  /* max-height: calc(var(--vh, 1vh) * 100 - 130px); */
  height: calc(100vh - 130px);
  /* height: calc(var(--vh, 1vh) * 100 - 130px); */
  overflow-y: auto;
  overflow-x: hidden;
}

.chat-container {
  overflow-x: hide !important;
  width: 360px;
}

.chat-container-inner {
  overflow-x: hide !important;
  -webkit-box-shadow: 0 2px 20px -1px rgba(0, 0, 0, 0.2),
    0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 20px -1px rgba(0, 0, 0, 0.2),
    0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
}

span.teneo-reply ul {
  padding-left: 17px !important;
}

.teneo-footer {
  -webkit-box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.12),
    0px -2px 0px 0 rgba(0, 0, 0, 0.08), 0px -3px 0px 0px rgba(0, 0, 0, 0.04);
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.12),
    0px -2px 0px 0 rgba(0, 0, 0, 0.08), 0px -3px 0px 0px rgba(0, 0, 0, 0.04);

  position: inherit;
  bottom: 0px !important;
  width: 100%;
  height: 60px;
  z-index: 5;
}

@media only screen and (max-width: 480px) {
  .v-footer,
  .chat-container,
  .teneo-dialog,
  .loading-ball {
    width: 100vw !important;
  }

  .chat-responses,
  .chat-responses-float {
    min-height: calc(100vh - 125px);
    /* min-height: calc(var(--vh, 1vh) * 100 - 125px); */
  }
}
</style>

<style>
.v-input__control{
  min-height: 30px !important;
}
</style>

